import type { DateFieldFormat, DateFieldUnit } from "./date-field.type";

const TRIGGER_ATTRIBUTE = "data-date-field-trigger";

const DEFAULT_FORMATS: Record<DateFieldUnit, DateFieldFormat> = { day: "L", month: "MM/YYYY", year: "YYYY" };

export { DEFAULT_FORMATS, TRIGGER_ATTRIBUTE };
